module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('h1', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center",
      "position": "relative"
    }
  }, [_vm._v("\n    Firebase Stats\n    "), _c('v-button', {
    staticClass: "refresh-button",
    attrs: {
      "disabled": _vm.loading,
      "title": "Refresh",
      "color": "secondary",
      "size": "icon"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadStats.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 4v6h6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 20v-6h-6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
    }
  })])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "2rem"
    }
  }, [_c('p', [_vm._v("Loading stats...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "2rem",
      "color": "red"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('v-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.loadStats.apply(null, arguments)
      }
    }
  }, [_vm._v("Retry")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.error) ? _c('div', [(_vm.billingStats) ? _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("Billable Metrics (Last 30 Days)")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Connections")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.billingStats.connections) + " / 200k")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v("Peak Concurrent")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Storage")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.formatBytes(_vm.billingStats.storage)))]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v("Current Total")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Downloads")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.formatBytes(_vm.billingStats.downloads)))]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v("Total (30 Days)")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("Collection Sizes (Approximated by Item Count)")]), _vm._v(" "), _c('p', {
    staticClass: "section-hint"
  }, [_vm._v("Click a collection to explore its objects")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, _vm._l((_vm.collectionStats), function(stat) {
    return _c('div', {
      key: stat.name,
      staticClass: "stat-card stat-card--clickable",
      class: {
        'stat-card--active': _vm.activeCollection === stat.name
      },
      on: {
        "click": function($event) {
          return _vm.openExplorer(stat.name)
        }
      }
    }, [_c('div', {
      staticClass: "stat-label"
    }, [_vm._v(_vm._s(stat.name))]), _vm._v(" "), _c('div', {
      staticClass: "stat-value"
    }, [_vm._v(_vm._s(stat.count))]), _vm._v(" "), (stat.estimatedSize !== 'N/A') ? _c('div', {
      staticClass: "stat-value-small"
    }, [_vm._v(_vm._s(stat.estimatedSize))]) : _vm._e(), _vm._v(" "), (stat.error) ? _c('div', {
      staticClass: "stat-error"
    }, [_vm._v("Error: " + _vm._s(stat.error))]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.activeCollection) ? _c('div', {
    staticClass: "stats-section explorer-panel"
  }, [_c('div', {
    staticClass: "section-header explorer-header"
  }, [_c('h2', [_vm._v("Exploring: "), _c('strong', [_vm._v(_vm._s(_vm.activeCollection))])]), _vm._v(" "), _c('v-button', {
    attrs: {
      "color": "secondary",
      "size": "icon",
      "title": "Close"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeExplorer.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "explorer-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.explorerObjectId),
      expression: "explorerObjectId"
    }],
    staticClass: "explorer-input",
    attrs: {
      "id": "explorer-id-input",
      "type": "text",
      "placeholder": "Enter object ID...",
      "disabled": _vm.explorerLoading
    },
    domProps: {
      "value": (_vm.explorerObjectId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchObject.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.explorerObjectId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-button', {
    attrs: {
      "disabled": _vm.explorerLoading || !_vm.explorerObjectId.trim()
    },
    nativeOn: {
      "click": function($event) {
        return _vm.fetchObject.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.explorerLoading ? 'Fetching...' : 'Fetch') + "\n        ")])], 1), _vm._v(" "), (_vm.explorerError) ? _c('p', {
    staticClass: "explorer-error"
  }, [_vm._v(_vm._s(_vm.explorerError))]) : _vm._e(), _vm._v(" "), (_vm.explorerData !== null) ? _c('div', {
    staticClass: "explorer-data"
  }, [_c('div', {
    staticClass: "explorer-data-header"
  }, [_c('span', {
    staticClass: "explorer-data-title"
  }, [_vm._v(_vm._s(_vm.activeCollection) + " / " + _vm._s(_vm.explorerObjectId))]), _vm._v(" "), (!_vm.confirmingDelete) ? _c('button', {
    staticClass: "delete-icon-btn",
    attrs: {
      "title": "Delete this object"
    },
    on: {
      "click": function($event) {
        _vm.confirmingDelete = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "3 6 5 6 21 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 11v6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 11v6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.confirmingDelete) ? _c('div', {
    staticClass: "delete-confirm-row"
  }, [_c('span', {
    staticClass: "delete-confirm-text"
  }, [_vm._v("Are you sure? This cannot be undone.")]), _vm._v(" "), _c('v-button', {
    attrs: {
      "color": "danger",
      "disabled": _vm.deleteLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmDelete.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.deleteLoading ? 'Deleting...' : 'Yes, Delete') + "\n          ")]), _vm._v(" "), _c('v-button', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.deleteLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmingDelete = false
      }
    }
  }, [_vm._v("\n            Cancel\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.deleteError) ? _c('p', {
    staticClass: "explorer-error"
  }, [_vm._v(_vm._s(_vm.deleteError))]) : _vm._e(), _vm._v(" "), (_vm.deleteSuccess) ? _c('p', {
    staticClass: "explorer-success"
  }, [_vm._v("Deleted successfully.")]) : _vm._e(), _vm._v(" "), (!_vm.deleteSuccess) ? _c('pre', {
    staticClass: "explorer-pre"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.explorerData, null, 2)))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20416dec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/FirebaseStats/FirebaseStats.vue
// module id = 1680
// module chunks = 2